var exports = {
  "E6": "ChannelEmbed.module__embed___a09XZV",
  "vO": "ChannelEmbed.module__embedFull___a09XZV",
  "UT": "ChannelEmbed.module__gridContainer___a09XZV",
  "Vg": "ChannelEmbed.module__grid___a09XZV",
  "$H": "ChannelEmbed.module__hasThumbnail___a09XZV",
  "zE": "ChannelEmbed.module__embedContent___a09XZV",
  "Cj": "ChannelEmbed.module__embedLink___a09XZV",
  "zC": "ChannelEmbed.module__embedProvider___a09XZV",
  "rN": "ChannelEmbed.module__embedAuthor___a09XZV",
  "QQ": "ChannelEmbed.module__embedAuthorName___a09XZV",
  "av": "ChannelEmbed.module__embedAuthorNameLink___a09XZV",
  "SG": "ChannelEmbed.module__embedAuthorIcon___a09XZV",
  "gt": "ChannelEmbed.module__embedTitle___a09XZV",
  "cD": "ChannelEmbed.module__embedDescription___a09XZV",
  "j0": "ChannelEmbed.module__embedFields___a09XZV",
  "Me": "ChannelEmbed.module__embedField___a09XZV",
  "$L": "ChannelEmbed.module__embedFieldName___a09XZV",
  "VN": "ChannelEmbed.module__embedFieldValue___a09XZV",
  "oy": "ChannelEmbed.module__embedFooterText___a09XZV",
  "W$": "ChannelEmbed.module__embedMedia___a09XZV",
  "ad": "ChannelEmbed.module__embedThumbnail___a09XZV",
  "te": "ChannelEmbed.module__embedFooter___a09XZV",
  "mG": "ChannelEmbed.module__embedFooterIcon___a09XZV",
  "i8": "ChannelEmbed.module__embedFooterSeparator___a09XZV",
  "PN": "ChannelEmbed.module__embedGifvContainer___a09XZV",
  "kL": "ChannelEmbed.module__container___a09XZV",
  "mQ": "ChannelEmbed.module__mediaFrame___a09XZV",
  "Mc": "ChannelEmbed.module__suppressButton___a09XZV",
  "wJ": "ChannelEmbed.module__mediaSuppressButton___a09XZV",
  "Fk": "ChannelEmbed.module__blueskyMediaEngagement___a09XZV",
  "Uf": "ChannelEmbed.module__blueskyGalleryMedia___a09XZV",
  "$j": "ChannelEmbed.module__blueskyEngagement___a09XZV",
  "Z": "ChannelEmbed.module__blueskyNestedEmbedContainer___a09XZV",
  "mx": "ChannelEmbed.module__blueskyNestedEmbed___a09XZV",
  "gp": "ChannelEmbed.module__blueskyNestedMediaEngagement___a09XZV",
  "qP": "ChannelEmbed.module__blueskyEngagementItem___a09XZV",
};

module.exports = exports;
